import type { TFunction } from "i18next";
import type { BadgeVariant } from "@/components/ui/badge/badge.variants";

export type PayrollRunPaymentStatus = "PAID" | "PARTIALLY_PAID" | "UNPAID" | null;

interface RunPaymentFields {
  paymentStatus?: PayrollRunPaymentStatus;
  paidCount?: number;
  payableCount?: number;
}

/**
 * How a processed run's payment reads (B34). The API marks a run COMPLETED the
 * moment its bank file exists; it is only "Paid" once every payable employee
 * is. Until then it reads "Processed · 2 of 15 paid".
 *
 * Returns null for a run that is not processed yet — the caller shows its
 * lifecycle status as before.
 */
export const payrollRunPaymentBadge = (
  run: RunPaymentFields,
  t: TFunction,
): { label: string; variant: BadgeVariant } | null => {
  if (!run.paymentStatus) return null;
  if (run.paymentStatus === "PAID") {
    return { label: t("company:payrolls.run_paid"), variant: "success" };
  }
  return {
    label: t("company:payrolls.run_processed_paid_count", {
      paid: run.paidCount ?? 0,
      payable: run.payableCount ?? 0,
    }),
    variant: "warning",
  };
};
